<div class="containerresize-overlay" *ngIf="resizableWidth !== '0px'" (click)="onOverlayClick($event)"></div>
<div class="containerresize" [ngClass]="{'full-width': containerWidth>=100}">
  <div class="drag-panel" (mousedown)="mouseDown($event)"></div>
  <div class="content" [ngStyle]="{ width: resizableWidth }">
    <div class="card-edit">
      <ng-content> </ng-content>
    </div>
  </div>
</div>
